import React, { useEffect, useRef, useState } from 'react';
import { useAppSelector } from '../../../redux/hooks';
import { rootState } from '../../../redux/store';
import useMousePosition from '../../../hooks/useMousePosition';
import { TextCustom } from '../../ui/TextCustom';
import { FlexCenter } from '../../layout/FlexCenter/FlexCenter';
import { colorMap, TColorRole } from '../../../types/types';
import { IToolTipItem } from '../../../interface/interfaces';
import { PanelLayout } from '../../layout/Panel/Panel';
import { Spacing } from '../../layout/Spacing/Spacing';
import IconComponent from '../../shared/IconComponents/IconComponent';

interface IToolTipProps {
    color?: TColorRole;
}

export const ToolTip: React.FC<IToolTipProps> = ({ color = 'dark' }) => {
    const { toolTipContent, showToolTip } = useAppSelector((state: rootState) => state.toolTip);
    const [leftPos, setLeftPos] = useState<number>(60);

    const { mousePosition } = useMousePosition();
    const [position, setPosition] = useState({ x: 0, y: 0 });

    // const [offset, setOffset] = useState({ x: -55, y: -22 });
    const hexColor = colorMap[toolTipContent.color] || colorMap['dark'];
    const tooltipRef = useRef<HTMLDivElement>(null);

    const [isTooltipVisible, setIsTooltipVisible] = useState(false);

    useEffect(() => {
        let delayTimer: NodeJS.Timeout;

        if (showToolTip) {
            delayTimer = setTimeout(() => {
                setIsTooltipVisible(true);
            }, toolTipContent.timer);
        } else {
            setIsTooltipVisible(false);
        }

        return () => {
            clearTimeout(delayTimer);
        };
    }, [showToolTip]);

    useEffect(() => {
        if (isTooltipVisible && tooltipRef.current) {
            const tooltipWidth = tooltipRef.current.offsetWidth;
            const tooltipHeight = tooltipRef.current.offsetHeight;
            const newX = mousePosition.x - tooltipWidth / 2;
            const newY = mousePosition.y - tooltipHeight - 10; // 10px iznad kursora

            const adjustedX = newX < 0 ? 0 : newX + tooltipWidth + leftPos > window.innerWidth ? window.innerWidth - tooltipWidth - leftPos : newX;

            setPosition({
                x: adjustedX,
                y: newY < 0 ? mousePosition.y + 20 : newY, // Ako nema mesta iznad, prikazi ispod kursora
            });
        }
    }, [mousePosition, isTooltipVisible]);

    return (
        <>
            {isTooltipVisible && (
                <div
                    ref={tooltipRef}
                    className={`tooltip tooltip__${toolTipContent.color} animation-zoom-2 ${toolTipContent.fixedSize ? 'tooltip__fixedSize' : ''}`}
                    style={{
                        position: 'absolute',
                        top: `${position.y - 0}px`,
                        left: `${position.x + 40}px`,
                        backgroundColor: `${hexColor}`,
                    }}
                >
                    {/* {
                        toolTipContent.color === 'dark'
                        &&
                        <div className='tooltip__arrow' style={{left: `${leftPos}px`}}></div>
                    } */}
                    <FlexCenter direction="h" position="start" gap={2}>
                        <PanelLayout stretch radius="s" color={`${toolTipContent.color}`} hasShadow={false} borderIntensity={0}>
                            <FlexCenter direction="v" position="start">
                                <IconComponent size={toolTipContent.iconSize || 1.6} iconName={toolTipContent.iconName} />
                                <TextCustom weight={toolTipContent.color === 'dark' ? 400 : 700} color={`${toolTipContent.color === 'dark' ? 'white' : 'dark'}`} size={1.4}>
                                    {toolTipContent.title}
                                </TextCustom>
                            </FlexCenter>
                        </PanelLayout>
                        <FlexCenter direction="h" position="start">
                            {toolTipContent &&
                                toolTipContent.toolTip.map((item: IToolTipItem, idx: number) => {
                                    return (
                                        <div key={idx}>
                                            {item.value && (
                                                <FlexCenter key={idx} position="start" gap={0.5}>
                                                    <TextCustom color={`${toolTipContent.color === 'dark' ? 'grey-normal' : 'dark'}`}>{item.label}:</TextCustom>
                                                    <PanelLayout
                                                        colorBorder={`${toolTipContent.color === 'dark' ? 'dark' : 'dark'}`}
                                                        radius="s"
                                                        borderIntensity={toolTipContent.color === 'dark' ? 0.05 : 0.1}
                                                        hasShadow={false}
                                                        color={`${toolTipContent.color === 'dark' ? 'dark-secondary' : 'grey-superLight'}`}
                                                    >
                                                        <Spacing marginSpacing="none" paddingSpacing="m">
                                                            <TextCustom weight={toolTipContent.color === 'dark' ? 400 : 700} color={toolTipContent.color === 'dark' ? 'white' : 'dark'}>
                                                                {item.value}
                                                            </TextCustom>
                                                        </Spacing>
                                                    </PanelLayout>
                                                </FlexCenter>
                                            )}
                                        </div>
                                    );
                                })}
                        </FlexCenter>
                    </FlexCenter>
                </div>
            )}
        </>
    );
};
